// import Link from 'next/link';
import React from 'react'
// import { useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Slider from "react-slick";
import { imageAddress, translate } from "../../../utils/useful"
// import Pagination from './pagination';
// import SliderBlogCard from './SliderBlogCard';



export default class SliderBlog extends React.Component {
    // export default function SliderBlog({ data, blogs, fullUrl }) {
    // const changePage = (index) => {

    //     let query = null

    //     if (this.props.category) {
    //         query = { category: this.props.category }
    //     }

    //     Router.push({
    //         pathname: "/blogs/" + (Number(index) + 1),
    //         query
    //     })

    // router.push("/blogs/" + (Number(index) + 1))
    // window.history.push( )
    // this.window.scrollTo(0, 0)
    // this.setState({ currentPage: index }, () => {
    //     this.fetch()
    // })


    // console.log(blogs)
    render() {
        return (

            <div>
                {/* <div className='row' style={{ display: "flex", flexDirection: "row", flexFlow: "row wrap", width: "100%" }}> */}
                {(this.props.data?.length == 0 || this.props.data == null) ? (

                    <p className='text-center text-muted mt-4'>{translate(`Found Nothing`)}</p>

                ) : (
                    <>
                        {/* <div className='col-12 col-md-6 col-lg-4 col-xl-3 mb-5'> */}
                        {/* <Link href={`/blog/${prop._id}`} > */}
                        <div className='w-100 h-100 d-flex flex-column text-start mb-3' style={{ color: '#4f4f4f' }}>
                            <div className='flex-1' style={{ display: "flex", flexDirection: "column" }}  >

                                {/* <img style={{ borderRadius: 15, width: "100%", }} src={imageAddress(prop?.image)} alt="" /> */}
                                <div className='position-relative w-100' style={{ paddingTop: '60%' }}>
                                    <img className='br-15 w-100 h-100' style={{ position: 'absolute', top: '0', left: '0', objectFit: 'cover' }} src={this.props.data.src} alt="" />
                                </div>

                                <div className='mt-3 px-2'>
                                    <h2 className='text-semibig'>{this.props.data.title}</h2>
                                    <p className='text-small'>{this.props.data.description.length < 30 ? this.props.data.description.length : this.props.data.description.substr(0, 50) + "..."}</p>
                                </div>
                            </div>
                            <div className='flexc mt-1 px-2'>
                                <button className='mrd-3 text-smaller color-blue' onClick={() => { }}>{translate(`Learn more`)}</button>
                                <img src="/images/right-arrow.png" height="13px" alt="" />
                            </div>
                        </div>
                        {/* </Link> */}
                        {/* </div> */}
                    </>
                )}

                {/* </div> */}
            </div>
        )
    }
}

//     return (
//         <div className="" >
//             <Link className="" href={{ pathname: '/blogs' }}>
//                 <a className="p-1  text-start ">
//                     <div className=" flexc px-2" style={{ background: !this.props.category ? 'rgb(0, 82, 204)' : '#fff', maxWidth: 200, borderRadius: 2, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 4 }}>
//                         {/* <div>
//         <img className="mt-1" src="https://images.unsplash.com/reserve/uZYSV4nuQeyq64azfVIn_15130980706_64134efc6e_o.jpg?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2067&q=80" style={{ height: 40, width: 40, borderRadius: 4, objectFit: 'cover' }} />
//       </div> */}
//                         <div className="mx-2 mt-2 mb-2 text-start">
//                             <p className="" style={{ color: !this.props.category ? '#fff' : 'rgb(0, 82, 204)', fontSize: 15, fontWeight: '', textTransform: 'uppercase' }}>{translate('all')}</p>
//                             <p className="m-0" style={{ color: !this.props.category ? '#ffffffaa' : '#789', fontSize: 11, lineHeight: 1, textTransform: 'uppercase' }}>{translate('Categories')}</p>
//                             {/* <p className="" style={{ color: '#789', fontSize: 13 }}>This is the test test for the description</p> */}
//                         </div>
//                     </div>
//                 </a>
//             </Link>


//             {this.props.categories?.map((prop, index) => {
//                 let active = false
//                 if (index == 0) {
//                     active = true
//                 }
//                 return (
//                     <Link className="" href={{ pathname: '/blogs/1', search: '?category=' + prop._id }}>
//                         <a className="p-1  text-start ">
//                             <div className=" d-flex px-2" style={{ background: this.props.category == prop._id ? 'rgb(0, 82, 204)' : '#fff', borderRadius: 2, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 4 }}>
//                                 <div>
//                                     <img className="mt-1" src={imageAddress(prop?.values.image, null, 'small')} style={{ height: 40, width: 40, borderRadius: 4, objectFit: 'cover' }} />
//                                 </div>
//                                 <div className="mx-2 mt-2 mb-1 pt-1 text-start">
//                                     <p className="m-0" style={{ color: this.props.category == prop._id ? '#ffffffaa' : 'rgb(0, 82, 204)', fontSize: 11, lineHeight: 1, textTransform: 'uppercase' }}>{translate('Category')}</p>
//                                     <p className="" style={{ color: this.props.category == prop._id ? '#fff' : '#102030', fontSize: 15, fontWeight: '', whiteSpace: 'nowrap' }}>{prop?.values.title}</p>
//                                     {/* <p className="" style={{ color: '#789', fontSize: 13 }}>This is the test test for the description</p> */}
//                                 </div>
//                             </div>
//                         </a>
//                     </Link>
//                 )
//             })}


//             <div className="container mb-5">
//                 <div className="row m-0">
//                     {this.props.blogs.map((item, index) => {
//                         return (
//                             <div className="col-12 col-sm-6 col-md-4 col-lg-3 p-2">
//                                 <Link href={{ pathname: '/blog/' + item._id }} >
//                                     <a>
//                                         <div className="mb-4 outline-none h-100 " >

//                                             <div className="w-100 h-100 d-flex flex-column" style={{ boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: '4px' }} >
//                                                 <div className="px-1 pt-1" style={{ flex: 1 }}>
//                                                     <img src={'https://platform.iotsmile.com/assets/uploads/' + item.image?.address} style={{ borderRadius: '4px 4px 0px 0px', width: '100%', height: '170px', objectFit: 'cover' }} />
//                                                     {/* <p className="box1-p1 ">USE CASE</p> */}
//                                                     <div className="px-3   flex-column  ">
//                                                         <p className="mt-3 mb-2" style={{ fontSize: '16px', fontWeight: '500', maxWidth: '260px' }}>{item.title}</p>
//                                                         {/* <p className="blogsbox-p3 mt-2">{item.cDate}</p> */}

//                                                         <p style={{ fontSize: '15px', fontWeight: '300' }}>{item.description}</p>
//                                                     </div>

//                                                 </div>
//                                                 <div className=" w-100 pb-3 px-3 ">
//                                                     {item?.teacher?.values?.name && (
//                                                         <p className='mb-2' style={{ fontSize: '13px', marginTop: '1px', color: 'rgb(0,0,0,0.6)', lineHeight: 1 }}>{checkTranslation("{{lang}}Writer")}: {item?.teacher?.values?.name}</p>
//                                                     )}
//                                                     <div className='flexcb w-100'>
//                                                         <div className=" flexc  ">
//                                                             <img className="mx-1" src="/images/icons/clock.png" style={{ width: '13px' }} />
//                                                             <p className="m-0" style={{ fontSize: '13px', marginTop: '1px', color: 'rgb(0,0,0,0.6)', lineHeight: 1 }}>{moment(item.cDate).format("jDD jMMMM , jYYYY")}</p>
//                                                         </div>
//                                                         <div className=" flexc ">
//                                                             {/* <img className="mx-1" src="/images/icons/clock.png"style={{width:'13px'}}/> */}
//                                                             <a><p style={{ fontSize: '15px', color: 'rgba(64, 117, 190, 1)' }}>{checkTranslation('{{lang}}Read-more')}</p></a>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </a>
//                                 </Link>
//                             </div>
//                         )
//                     }
//                     )}
//                     <div className="col-12 mt-4">
//                         <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.changePage} />

//                     </div>


//                     {this.props.blogs?.length == 0 && (
//                         <div className="flexcc w-100 mb-5">
//                             <p>Nothing Found</p>
//                         </div>
//                     )}
//                 </div>
//             </div>

//         </div>);
// }
